<template>
  <v-breadcrumbs :items="items" class="pa-0 ma-0">
    <template v-slot:item="{ item }">
      <router-link
        :key="`${item.text}-${item.index}`"
        :disabled="item.disabled"
        :exact="item.exact"
        :to="item.to"
        style="text-decoration: none;"
      >
        <span
          class="blue-grey--text subtitle-2 font-weight-regular"
          :class="{ 'text--darken-1': !item.disabled }"
        >
          {{ item.text }}
        </span>
      </router-link>
    </template>

    <template v-slot:divider>
      <v-icon color="blue-grey text--darken-1">mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  props: ['links'],

  computed: {
    items() {
      return this.links.map((link, index) => ({
        disabled: link.disabled ?? false,
        exact: link.exact ?? false,
        index,
        to: link.to ?? { path: link.href },
        text: link.name,
      }))
    },
  },
}
</script>
